import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'categorylist',

  data() {
    return {
      categorySort: {
        key: 'order',
        order: 'asc'
      }
    }
  },

  computed: {
    ...mapGetters('itemlist', ['savedCategoryId']),

    ...mapGetters('category', [
      'predictSelectedCategoryId',
      'category'
    ]),

    /**
     * カテゴリ一覧
     * ソートはカテゴリIDで行う
     */
    categorys() {
      return _.orderBy(
        this.getCategorys_(),
        category => category.order,
        this.categorySort.order
      )
    }
  },

  methods: {
    ...mapActions('itemlist', ['getItemlist']),
    ...mapActions('skulist', ['resetSkulist']),
    ...mapActions('predict', ['resetPredict']),
    ...mapActions('detail', ['resetDetail']),

    ...mapActions('category', [
      'getCategory',
      'setPredictSelectedCategoryId'
    ]),

    /**
     * カテゴリ一覧取得
     * 連想配列から配列に変換して返却
     */
    getCategorys_() {
      const list = []
      _.forEach(this.category, cate => {
        list.push({
          id: cate.category_id,
          name: cate.category_name,
          order: cate.sort_order
        })
      })
      return list
    },

    /**
     * ソート変更
     */
    changeCategorySortOption(key) {
      this.categorySort.key = key
      this.categorySort.order = this.categorySort.order === 'asc' ? 'desc' : 'asc'
    },

    /**
     * カテゴリを選択
     * 予測画面の全てを再描画。アイテム一覧以外は初期化
     */
    selectCategory(categoryId) {
      // ページ遷移を考慮し、アイテム一覧のカテゴリIDと同じカテゴリの場合は、更新しない
      if (this.savedCategoryId === categoryId) return

      this.setPredictSelectedCategoryId(categoryId)
      this.resetSkulist()
      this.resetPredict()
      this.resetDetail()
      this.getItemlist({ categoryId: categoryId })
    },

    /**
     * 動的CSS
     */
    cssCategoryHeaderSort(col) {
      return {
        'sort-active': this.categorySort.key === col,
        'sort-isAsc': this.categorySort.order === 'asc'
      }
    },

    // 動的css。カテゴリ一覧選択行
    selectRow(categoryId) {
      return this.predictSelectedCategoryId === categoryId ? 'category-list__row--selected' : ''
    },

    /**
     * 画面表示時
     * カテゴリを選択
     */
    created_() {
      this.getCategory()
      this.selectCategory(this.predictSelectedCategoryId)
    },

    /**
     * ページ遷移時に選択しているカテゴリまでスクロール
     * カテゴリ名が全角12文字を超えた場合は改行されるためスクロール幅を調整
     */
    scrollCategory_() {
      if (this.categorys.length === 0) return
      const body = document.querySelector('.category-list__body')
      const idx = _.findIndex(this.categorys, { id: this.predictSelectedCategoryId })
      body.scrollTop = body.childNodes[idx].offsetTop - 46
    },

    changeFocusByUpKey(list, currentIndex) {
      if (currentIndex === 0) return
      document.getElementById(`category-${currentIndex - 1}`).focus()
    },

    changeFocusByDownKey(list, currentIndex) {
      if (currentIndex === list.length - 1) return
      document.getElementById(`category-${currentIndex + 1}`).focus()
    }
  },

  created() {
    this.created_()
  },

  mounted() {
    this.scrollCategory_()
  }
}



// WEBPACK FOOTER //
// ./src/components/aftersale/predict/categorylist/categorylist.js